import { render, staticRenderFns } from "./addDImodel.vue?vue&type=template&id=a899a1b4&scoped=true"
import script from "./addDImodel.vue?vue&type=script&lang=js"
export * from "./addDImodel.vue?vue&type=script&lang=js"
import style0 from "./addDImodel.vue?vue&type=style&index=0&id=a899a1b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a899a1b4",
  null
  
)

export default component.exports